import React, {Component} from 'react';
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import CreatableSelect from "react-select/lib/Creatable";

import request from "../../../../Services/API/Requests";
import {
    Control,
    Option,
    Placeholder,
    ValueContainer,
    MultiValue,
    Menu
} from "../../../ReactSelectMaterial/Suggestions";
import listRequestWrapper from "../../../../Services/API/listRequestWrapper";

const components = {
    Control,
    Option,
    Placeholder,
    ValueContainer,
    MultiValue,
    Menu
};

const styles = () => ({
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
        ['@media (max-height: 650px)']: { // eslint-disable-line no-useless-computed-key
            maxHeight: 150,
            overflowY: 'scroll',
        },
        ['@media (max-height: 590px)']: { // eslint-disable-line no-useless-computed-key
            maxHeight: 100,
            overflowY: 'scroll',
        },
    },
    paper: {
        position: 'absolute',
        zIndex: 9999999,
        overflow: 'hidden',
        left: 0,
        right: 0,
    },
});

class TypeSuggestions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            suggestions: []
        }
    }


    async componentDidMount() {
        const {element} = this.props;
        if (element.source) {
            const suggestions = await listRequestWrapper(element.source);
            let newSuggestions = [];
            suggestions.forEach(source => {
                newSuggestions.push({value: source.id, label: source.name})
            });
            this.setState({suggestions: newSuggestions})
        }
    }


    renderField = () => {
        const {classes, onChangeSuggestions, values, element} = this.props;
        const {suggestions} = this.state;
        const customStyles = {
            dropdownIndicator: () => ({
                display: 'none'
            }),
            indicatorSeparator: () => ({
                display: 'none'
            }),
            clearIndicator: () => ({display: 'none'}),
            menuPortal: base => ({ ...base, zIndex: 9999 })
        };
        return (
            <CreatableSelect
                id={`${element.name}Props`}
                swapItems={() => {}}
                isClearable
                menuPortalTarget={document.body}
                styles={customStyles}
                classes={classes}
                fullWidth={true}
                name={element.name}
                isDisabled={element.disabled}
                components={components}
                disableUnderline={true}
                onChange={(newValue) => onChangeSuggestions(newValue, element.name)}
                value={values[element.name] !== undefined ? (
                    {value: values[element.name], label: values[element.name]}
                ) : ''}
                options={suggestions || []}
            />
        )
    };

    render() {
        return (
            this.renderField()
        );
    }

}
TypeSuggestions.propTypes = {
    element: PropTypes.object.isRequired,
    path: PropTypes.string,
    onChangeSuggestions: PropTypes.func.isRequired,
    values: PropTypes.any.isRequired
};

export default withStyles(styles)(TypeSuggestions);